var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArchived(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8418_5579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0117 17.0755C16.3465 16.5768 17.2969 15.29 17.2969 13.7812V7.10156C17.2969 5.54825 16.0377 4.28906 14.4844 4.28906H6.39844C4.84513 4.28906 3.58594 5.54825 3.58594 7.10156V14.168M9.77344 1.86328C9.13004 1.15084 8.17225 0.703125 7.13672 0.703125H4.21875C2.27714 0.703125 0.703125 2.27714 0.703125 4.21875V13.7812C0.703125 15.7229 2.27714 17.2969 4.21875 17.2969H6.11719",
    stroke: "#A3A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.409 9.5625V14.168M12.7634 15.5391L11.4502 16.8729C10.8849 17.4382 9.96831 17.4382 9.403 16.8729L8.08984 15.5391",
    stroke: "#4CBC18",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8418_5579"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArchived);
export default __webpack_public_path__ + "static/media/icon-archived.551a2e84e7c9c6a844e719aa3284f14b.svg";
export { ForwardRef as ReactComponent };